// Header mega-menu hover js
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
    });
  });


//Cupan code Section
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {

    copyBtn.addEventListener("click", function () {

      let link = this.closest(".coupan-right-block").querySelector(".copy-link");

      if (link) {
        let url = link.href;

        navigator.clipboard.writeText(url).then(() => {

          let originalContent = copyBtn.innerHTML;

          // ✅ SVG Tick Icon
          let successSVG = `
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="24" fill="#28a745"/>
                <path d="M16 24L21 29L32 18" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          `;

          // Replace button content
          copyBtn.innerHTML = successSVG;

          setTimeout(() => {
            copyBtn.innerHTML = originalContent;
          }, 2000);

        }).catch(err => {
          console.error("Copy failed", err);
        });
      }

    });

  });
});


// blog FAQ js
document.addEventListener("DOMContentLoaded", function () {

  const accordions = document.querySelectorAll(".this-article-point");

  accordions.forEach(function (section) {

    const content = section.querySelector(".article-point-wrapper");

    // ✅ Open by default
    section.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    const toggle = section.querySelector(".accordion-toggle");

    toggle.addEventListener("click", function () {

      section.classList.toggle("active");

      if (section.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = "0px";
      }

    });

  });

});

////////////////

document.addEventListener("DOMContentLoaded", function () {

  const headings = document.querySelectorAll(".acc-block-wrap .acco-head");

  headings.forEach((heading) => {
    const content = heading.nextElementSibling;

    // ✅ Default state
    if (heading.classList.contains("active")) {
      content.style.display = "block";
    } else {
      content.style.display = "none";
    }

    heading.addEventListener("click", function () {

      // Close all others
      headings.forEach((otherHeading) => {
        if (otherHeading !== heading) {
          otherHeading.classList.remove("active");
          otherHeading.nextElementSibling.style.display = "none";
        }
      });

      // Toggle current (FAST)
      heading.classList.toggle("active");

      if (heading.classList.contains("active")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }

    });
  });

});
